import type { UiMessages } from "../types";

export const pt: UiMessages = {
  nav: {
    streams: "Ao vivo",
    videos: "Vídeos",
    shorts: "Shorts",
    forYou: "Para você",
    vr: "VR",
    cartoon: "Desenhos",
    hentai: "Hentai",
    sections: "Mais",
    menu: "Menu",
    game: "Jogo porno",
    stories: "Contos eróticos",
    escorts: "Acompanhantes",
    ai: "Namoradas IA",
    paysites: "Sites premium",
    home: "Início",
    following: "Seguindo",
    watching: "Assistindo",
    rankings: "Rankings",
    invite: "Convidar amigos",
    coins: "Sweet Coin",
    achievements: "Conquistas",
    hot: "Em alta agora",
    random: "Vídeo aleatório",
    saved: "Salvos",
    reacted: "Reações",
    boost: "Sweet Boost",
    premium: "Premium",
    stars: "Estrelas pornô",
    productions: "Estúdios",
    categories: "Categorias",
    telegram: "Canal no Telegram",
    allSections: "Todas as seções",
    mainNavigation: "Navegação principal",
    quickNavigation: "Navegação rápida",
    show: "Mostrar",
    coinsReady: "Sweet Coins prontas para coletar",
    logIn: "Entrar",
    search: "Buscar",
    closeSearch: "Fechar busca",
    language: "Idioma",
    theme: "Tema",
    themeDark: "Escuro",
    themeLight: "Claro",
  },
  age: {
    parents: "Pais: nossa página de {link} explica como bloquear o acesso a este site. O Sweet tem o selo RTA.",
    parentalControls: "controle parental",
    title: "Este é um site adulto",
    body: "Este site contém material com restrição de idade, incluindo nudez e cenas explícitas de atividade sexual. Ao entrar, você confirma que tem pelo menos 18 anos, ou a maioridade legal no lugar de onde acessa o site, e que concorda em ver conteúdo sexualmente explícito.",
    enter: "Tenho 18 anos ou mais — Entrar",
    exit: "Tenho menos de 18 anos — Sair",
  },
  consent: {
    title: "Cookies",
    body: "O Sweet é grátis graças aos anúncios. Nossos parceiros de publicidade usam cookies para exibi-los e contar suas visualizações e cliques. O armazenamento necessário, como a confirmação da sua idade, funciona de qualquer jeito.",
    privacy: "Política de Privacidade",
    acceptAll: "Aceitar todos",
    onlyNecessary: "Só os necessários",
    settings: "Configurações de cookies",
  },
  ago: { now: "agora", m: "{n} min", h: "{n} h", d: "{n} d", w: "{n} sem", mo: "{n} m", y: "{n} a" },
  cams: {
    allPlatforms: "Todas as plataformas",
    watchOnSite: "Assistir no {site}",
    liveFor: "ao vivo há {time}",
    tryAnother: "Tente outra tag ou outra região, ou volte daqui a pouco.",
    nobodyLiveOn: "Ninguém está ao vivo no {name} agora",
    platformShowUpHint: "As transmissões do {name} aparecem aqui assim que começam. Volte daqui a pouco.",
    liveNowCount: "{n} ao vivo agora",
    opensOn: "elas abrem no {site}",
    streamerSite: "site da transmissão",
    orWatch: "Ou assista {link}.",
    videoTag: "vídeos de #{tag}",
    liveStreams: "Transmissões ao vivo",
    platformStreams: "Transmissões ao vivo do {name}",
    liveCams: "Câmeras ao vivo",
    platformCams: "Câmeras do {name}",
    moreLiveCams: "Mais câmeras ao vivo",
    byTopic: "Câmeras ao vivo por tema",
    breadcrumb: "Trilha de navegação",
    live: "Ao vivo",
    viewers: "Espectadores:",
    isLive: "{name} está ao vivo",
    watchOn: "{title} — assista ao vivo no {site}",
    nobodyLive: "Ninguém ao vivo agora",
    noMatch: "Nenhuma transmissão ao vivo com esses filtros",
    showUpHint: "As transmissões aparecem aqui assim que começam. Volte daqui a pouco.",
    clearFilters: "Limpar filtros",
    clearAll: "Limpar tudo",
    clear: "Limpar",
    seeAllPlatforms: "Ver todas as plataformas",
    watchVideos: "Ver vídeos",
    onPlatform: " no {name}",
    newOnTelegram: "Novas câmeras ao vivo no Telegram",
    loadMoreFailed: "Não deu para carregar mais — tente de novo",
    platforms: "Plataformas",
    streamPlatforms: "Plataformas de transmissão",
    platformsAndFilters: "Plataformas de transmissão e filtros",
    categories: "Categorias",
    all: "Todos",
    region: "Região",
    allRegions: "Todas as regiões",
    more: "Mais",
    newModels: "Modelos novos",
    tags: "Tags",
    removeTag: "Remover tag",
    remove: "Remover",
    loading: "Carregando",
    offline: "Offline",
    seeAll: "Ver tudo",
    genders: { female: "Mulheres", male: "Homens", couple: "Casais", trans: "Trans" },
    regions: { north_america: "América do Norte", south_america: "América do Sul", europe: "Europa e Rússia", asia: "Ásia", other: "Outras regiões" },
  },
  video: {
    fullScene: "Ver a cena completa em {site}",
    upNext: "A seguir",
    nextPage: "Próxima página",
    moreVideos: "Mais vídeos",
    end: "Você chegou ao fim.",
    loadMoreFailed: "Não deu para carregar mais — tente de novo",
    likes: "Curtidas",
    premiumVideo: "Vídeo Premium",
    subscribeToWatch: "Assine para ver este vídeo completo.",
    getPremium: "Seja Premium",
    logIn: "Entrar",
    playsIn: "Reproduz no player do {name}",
    partnerBlocked: "O vídeo é reproduzido pelos servidores de {name}, que não respondem na sua rede: {name} pode estar bloqueado pelo seu provedor ou no seu país.",
    unavailable: "{name} não exibe seus vídeos no seu país, então não dá para assistir a este aqui.",
    watchCams: "Ver câmeras ao vivo",
    chatLive: "Converse ao vivo com {name} no {site}",
    play: "Reproduzir {title}",
    sponsored: "Patrocinado",
    onlyfansCreators: "Criadores do OnlyFans",
    liveNowFree: "Ao vivo agora · grátis",
    allVideos: "Todos os vídeos",
    stoppedAt: "Parou em {at} de {of}",
    watchedToEnd: "Assistido até o fim",
  },
  profile: { followers: "Seguidores", views: "Visualizações", videos: "Vídeos", verified: "Verificado", follow: "Seguir", unfollow: "Deixar de seguir" },
  lists: {
    categories: "Categorias",
    popular: "Populares",
    aToZ: "A – Z",
    jumpToLetter: "Ir para a letra",
    allCategories: "Todas as categorias",
    noVideosYet: "Ainda não há vídeos aqui",
    pageN: "Página {n}",
    newEveryDay: "Vídeos novos são adicionados todos os dias.",
    videoCount: "{n} vídeos",
    pornstars: "Estrelas pornô",
    pornstarsIntro: "As estrelas mais seguidas da semana.",
    studios: "Estúdios pornô",
    studiosIntro: "Produtoras e canais, ordenados por número de seguidores.",
    noVideosWithTag: "Nenhum vídeo com esta tag",
    showAllVideos: "Mostrar todos os vídeos",
  },
  hot: {
    title: "Em alta agora",
    intro: "Os vídeos mais assistidos no Sweet nas últimas horas.",
  },
  comments: {
    title: "Comentários",
    placeholder: "Escreva um comentário…",
    post: "Publicar",
    login: "Entre para comentar",
    coinsHint: "+{n} moedas por cada um dos seus primeiros {max} comentários do dia",
    earned: "+{n} moedas",
    empty: "Ainda sem comentários. Seja o primeiro.",
    more: "Ver mais",
    delete: "Excluir",
    short: "Escreva um pouco mais.",
    long: "Longo demais: no máximo {n} caracteres.",
    links: "Links e contatos não são permitidos nos comentários.",
    forbidden: "Este comentário não pode ser publicado.",
    rate: "Você está comentando rápido demais. Tente mais tarde.",
    duplicate: "Você já publicou isto.",
    failed: "Não foi possível publicar. Tente de novo.",
    like: "Gostei",
    dislike: "Não gostei",
    rateLogin: "Entre para avaliar vídeos",
    liked: "{p}% gostaram",
  },
  starVote: {
    title: "Estrela do mês",
    vote: "Votar",
    voteFor: "Vote em {name} como estrela do mês",
    voteAgain: "Votar de novo · {n} moedas",
    confirm: "Gastar {n} moedas?",
    standing: "Nº {rank} este mês · votos: {n}",
    noVotes: "Ainda sem votos este mês",
    thanks: "Obrigado pelo seu voto!",
    paidThanks: "Voto contado · −{n} moedas",
    coins: "Moedas insuficientes: um voto custa {n}.",
    limit: "Você já usou todos os votos de hoje.",
    rules: "Um voto grátis por dia, depois {n} moedas por voto.",
    boardIntro: "Os membros votam nas suas estrelas favoritas nas páginas delas: um voto grátis por dia e mais por {n} moedas cada.",
    boardEmpty: "Ainda sem votos este mês. Vote numa estrela na página dela.",
    votes: "Votos",
    lastWinner: "Estrela do mês passado",
    login: "Entre para votar",
  },
  achievements: {
    title: "Conquistas",
    intro: "Desbloqueie conquistas enquanto assiste, segue e participa. Cada uma dá Sweet Coins.",
    unlocked: "Desbloqueada",
    coins: "+{n} moedas",
    progress: "{x} de {n}",
    total: "{x} de {n} desbloqueadas",
    login: "Entre para ganhar conquistas e suas moedas.",
    signup: "Criar conta",
    toast: "Conquista desbloqueada",
    names: {
      "videos-1": ["Primeiro vídeo", "Assista ao seu primeiro vídeo"],
      "videos-10": ["Aquecendo", "Assista a 10 vídeos"],
      "videos-100": ["Frequentador", "Assista a 100 vídeos"],
      "videos-1000": ["Conhecedor", "Assista a 1.000 vídeos"],
      "hours-1": ["Uma hora", "Assista por uma hora"],
      "hours-10": ["Dez horas", "Assista por 10 horas"],
      "hours-100": ["Maratona", "Assista por 100 horas"],
      "streak-3": ["Três seguidos", "Assista 3 dias seguidos"],
      "streak-7": ["Sequência semanal", "Assista todos os dias por uma semana"],
      "streak-30": ["Sequência mensal", "Assista todos os dias por 30 dias"],
      "follows-5": ["Fã", "Siga 5 estrelas ou produtoras"],
      "likes-25": ["Coração grande", "Curta 25 vídeos"],
      "saves-10": ["Colecionador", "Salve 10 vídeos"],
      "days-7": ["Semana de moedas", "Pegue moedas em 7 dias"],
      "days-30": ["Mês de moedas", "Pegue moedas em 30 dias"],
      "invites-1": ["Traga um amigo", "Convide um amigo que se cadastre"],
      "comments-1": ["Primeiras palavras", "Escreva seu primeiro comentário"],
      "comments-25": ["Falante", "Escreva 25 comentários"],
      "votes-1": ["Eleitor", "Vote na estrela do mês"],
    },
  },
  pwa: {
    appName: "App do Sweet",
    bannerLabel: "Instalar o app",
    bannerPitch: "Tela cheia, sem loja de apps",
    install: "Instalar",
    notNow: "Agora não",
    installApp: "Instalar o app",
    howToInstall: "Como instalar",
    inApp: "Você está usando o app.",
    cardPitch: "Tela cheia, a um toque da sua Tela de Início. Sem loja de apps.",
    manual: "Abra o menu do navegador e escolha {install} ou {add}.",
    iosTitle: "Adicione o Sweet à sua Tela de Início",
    iosShare: "Toque em {share} na barra do navegador (no iOS 26: {more} e depois {share})",
    iosAdd: "Escolha {add}",
    iosConfirm: "Toque em {confirm}: o Sweet abre em tela cheia pela sua Tela de Início",
    share: "Compartilhar",
    more: "•••",
    add: "Adicionar à Tela de Início",
    confirm: "Adicionar",
    installMenu: "Instalar app",
    gotIt: "Entendi",
    close: "Fechar",
    offlineTitle: "Você está offline",
    offlineBody: "O Sweet precisa de internet para vídeos e cams. Verifique sua conexão e tente de novo.",
    retry: "Tentar de novo",
    recent: "Abertas recentemente",
  },
  notifications: {
    title: "Notificações",
    empty: "Nada de novo ainda. Siga estrelas e produtoras ou adicione modelos de webcam aos favoritos, e as novidades delas aparecem aqui.",
    newVideos: "Vídeos novos",
    liveNow: "Ao vivo agora",
    markRead: "Marcar tudo como lido",
    pushOn: "Ativar notificações",
    pushOff: "Desativar notificações",
    pushHint: "Saiba de vídeos novos e de favoritas ao vivo mesmo com o Sweet fechado.",
    pushBlocked: "As notificações do Sweet estão bloqueadas nas configurações do seu navegador.",
    pushUnsupported: "Este navegador não mostra notificações. No iPhone, adicione o Sweet à tela de início primeiro.",
    pushEnabled: "Notificações ativadas",
    favorites: "Modelos favoritas",
    addFavorite: "Adicionar aos favoritos",
    removeFavorite: "Remover dos favoritos",
    favoritesEmpty: "Nenhuma modelo favorita ainda. Toque no coração de uma webcam para adicionar.",
    offline: "Offline",
    viewAll: "Ver tudo",
  },
  forYou: {
    title: "Para você",
    all: "Todos",
    continueWatching: "Continuar assistindo",
    intro: "Escolhidos a partir do que você curte, salva, assiste e segue.",
    empty: "Curta, salve ou siga alguns vídeos e estrelas, e aqui vão aparecer vídeos escolhidos para você.",
    more: "Mais",
  },
  shorts: {
    straight: "Hétero",
    gay: "Gay",
    trans: "Trans",
    watchFull: "Ver vídeo completo",
    like: "Curtir",
    liked: "Curtido",
    save: "Salvar",
    saved: "Salvo",
    share: "Compartilhar",
    copied: "Link copiado",
    soundOn: "Ativar som",
    soundOff: "Desativar som",
    tapForSound: "Toque para ativar o som",
    report: "Denunciar",
    follow: "Seguir",
    following: "Seguindo",
    previous: "Anterior",
    next: "Próximo",
    close: "Fechar",
    end: "Por enquanto é só. Mais em Vídeos.",
    empty: "Ainda não há shorts aqui.",
    live: "Ao vivo",
    watchLive: "Assistir ao vivo grátis",
    watching: "{n} assistindo",
    profile: "Perfil",
    moreLive: "Mais cams ao vivo",
  },
  search: {
    searches: "Pesquisas",
    popular: "Pesquisas populares",
    categories: "Categorias",
    searchFor: "Buscar vídeos de “{q}”",
    nothingFor: "Nada encontrado para “{q}”.",
    title: "Buscar no Sweet",
    placeholder: "Busque vídeos, pessoas e marcas",
    hint: "Encontre vídeos, estrelas, produtoras e categorias. Aperte / em qualquer lugar para começar a digitar.",
    stars: "Estrelas",
    productions: "Produtoras",
    other: "Outros",
    otherProfiles: "Outros perfis",
    nothing: "Nada encontrado",
    tryAgain: "Confira a ortografia ou tente um termo mais amplo.",
    backHome: "Voltar ao início",
  },
  notFound: { title: "Esta página não existe", body: "O vídeo pode ter sido removido, ou o link foi digitado errado.", home: "Ir para o início" },
  common: {
    close: "Fechar",
    copy: "Copiar",
    copied: "Copiado",
    more: "Mais",
    loading: "Carregando",
    clearAll: "Limpar tudo",
    browseVideos: "Ver vídeos",
    scrollLeft: "Rolar para a esquerda",
    scrollRight: "Rolar para a direita",
  },
  actions: {
    react: "Curtir",
    reacted: "Curtido",
    save: "Salvar",
    saved: "Salvo",
    follow: "Seguir",
    following: "Seguindo",
    followName: "Seguir {name}",
    unfollowName: "Deixar de seguir {name}",
    moreOptions: "Mais opções",
    share: "Compartilhar",
    copyLink: "Copiar link",
    linkCopied: "Link copiado",
    report: "Denunciar",
    home: "Sweet — início",
    onSweet: "{name} no Sweet",
    joinMe: "Vem comigo no Sweet",
    inviteLink: "Seu link de convite",
  },
  library: {
    savedEmpty: "Nada salvo ainda",
    savedHint: "Toque no marcador embaixo de qualquer vídeo para guardá-lo aqui. Sua lista fica salva só neste dispositivo.",
    reactedEmpty: "Nenhuma reação ainda",
    reactedHint: "Os vídeos que você marca com coração aparecem aqui, os mais novos primeiro.",
    watchingEmpty: "Nada assistido ainda",
    watchingHint: "Os vídeos que você dá play aparecem aqui com o momento exato em que você parou, e continuam dali quando você os abre de novo.",
    removeWatching: "Remover do histórico",
    removeVideo: "Remover {title} do histórico",
    followingEmpty: "Você ainda não segue ninguém",
    followingHint: "Toque no + de uma criadora ou estúdio e os vídeos mais novos deles vão se juntar aqui. Quem você segue fica salvo só neste dispositivo.",
    discoverModels: "Descobrir modelos",
    noVideosHint: "Tente outra categoria — chegam vídeos novos todos os dias.",
    backToAll: "Voltar para todos os vídeos",
  },
  player: {
    resumesAt: "Continua em {at}",
    startOver: "Começar do início",
    unavailable: "Este vídeo não está disponível agora.",
    play: "Reproduzir",
    pause: "Pausar",
    seek: "Avançar ou voltar",
    back10: "Voltar 10 segundos",
    forward10: "Avançar 10 segundos",
    mute: "Silenciar",
    unmute: "Ativar som",
    volume: "Volume",
    settings: "Configurações",
    pip: "Picture-in-picture",
    fullscreen: "Tela cheia",
    exitFullscreen: "Sair da tela cheia",
    quality: "Qualidade",
    speed: "Velocidade",
    normal: "Normal",
    auto: "Auto",
    partner: "o parceiro",
  },
  ads: { ad: "Anúncio", advertisement: "Publicidade", muteAd: "Silenciar anúncio", unmuteAd: "Ativar som do anúncio", skipIn: "Pular em {n}", skipAd: "Pular anúncio ›" },
  auth: {
    username: "Nome de usuário",
    usernameOrEmail: "Usuário ou e-mail",
    emailOptional: "E-mail (opcional)",
    password: "Senha",
    currentPassword: "Senha atual",
    newPassword: "Nova senha",
    confirmPassword: "Confirme a senha",
    confirmNewPassword: "Confirme a nova senha",
    showPassword: "Mostrar senha",
    hidePassword: "Ocultar senha",
    forgot: "Esqueceu a senha?",
    remember: "Manter conectado",
    logIn: "Entrar",
    createAccount: "Criar conta",
    usernameHelp: "De 3 a 24 letras, números, pontos ou sublinhados. Aparece nos Rankings.",
    emailHelp: "Usado só para redefinir sua senha. Você pode adicionar depois na sua conta.",
    passwordHelp: "Pelo menos 8 caracteres.",
    adult: "Tenho 18 anos ou mais.",
    agree: "Concordo com os {terms} e a {privacy}.",
    terms: "Termos",
    privacy: "Política de Privacidade",
    savePhrasesTitle: "Salve suas frases de recuperação",
    savePhrasesBody: "Você se cadastrou sem e-mail, então estas frases são o jeito de voltar se esquecer a senha.",
    continue: "Continuar",
    resetHow: "Como redefinir sua senha",
    byEmail: "Receber um link por e-mail",
    byPhrase: "Usar uma frase de recuperação",
    phraseIntro: "Para contas criadas sem e-mail: digite seu nome de usuário e qualquer uma das frases de recuperação que você salvou no cadastro.",
    phrase: "Frase de recuperação",
    phrasePlaceholder: "palavra palavra palavra palavra",
    phraseHelp: "As 4 palavras de uma frase. Cada frase funciona uma vez.",
    saveNewPassword: "Salvar nova senha",
    sendLink: "Enviar link de redefinição",
  },
  phrases: {
    warning: "Salve agora: elas não vão aparecer de novo. Se esquecer a senha, seu nome de usuário e qualquer uma destas frases permitem escolher uma nova. Cada frase funciona uma vez. Não mostre a ninguém.",
    list: "Suas frases de recuperação",
    copyAll: "Copiar todas",
    download: "Baixar .txt",
    savedCheck: "Salvei minhas frases de recuperação em um lugar seguro.",
    done: "Pronto",
    fileTitle: "Frases de recuperação do Sweet para @{username}",
    fileHow: "Se esquecer a senha, acesse {url}, escolha “{option}” e digite seu nome de usuário e qualquer uma destas frases.",
    filePrivate: "Cada frase funciona uma vez. Não mostre a ninguém: quem tiver seu nome de usuário e uma destas frases pode tomar sua conta.",
    none: "Sua conta não tem e-mail nem frases de recuperação. Se esquecer a senha, não vai conseguir voltar. Crie frases de recuperação agora.",
    optional: "As frases de recuperação permitem escolher uma nova senha sem e-mail. São opcionais enquanto sua conta tiver um e-mail.",
    left: "{left} de {total} frases não usadas.",
    leftMade: "{left} de {total} frases não usadas, criadas em {date}.",
    how: "Cada uma, com seu nome de usuário, permite escolher uma nova senha uma vez. Perdeu? Crie novas e as antigas deixam de funcionar.",
    make: "Criar frases de recuperação",
    makeNew: "Criar novas frases",
  },
  account: {
    menu: "Menu da conta",
    settings: "Configurações da conta",
    profiles: "Seus perfis",
    logOut: "Sair",
    uploadPhoto: "Enviar foto",
    removePhoto: "Remover a foto atual",
    displayName: "Nome de exibição",
    showInRankings: "Mostrar meu nome nos Rankings",
    rankingsHelp: "Seu nome, foto e estatísticas de visualização aparecem nos {link} públicos. Desative para ficar de fora; seu tempo continua contando.",
    save: "Salvar",
    emailHelp: "Usado só para enviar um link se você esquecer a senha. Deixe vazio para removê-lo.",
    saveEmail: "Salvar e-mail",
    changePassword: "Alterar senha",
    deleteWarning: "Isso apaga para sempre sua conta, vídeos salvos, reações e quem você segue. Não dá para desfazer.",
    typeToConfirm: "Digite {word} para confirmar",
    deleteMine: "Excluir minha conta",
  },
  pay: {
    billingPeriod: "Período de cobrança",
    monthly: "Mensal",
    yearly: "Anual",
    yourPlan: "Seu plano",
    month: "mês",
    year: "ano",
    oneMonth: "1 mês",
    months: "{n} meses",
    oneYear: "1 ano",
    years: "{n} anos",
    perMonth: "{price} por mês",
    save: "Economize {n}%",
    comingSoon: "Em breve",
    reward: "−{n}% sua recompensa",
    plays: "{n} partidas no Sweet Room",
    addedAtOnce: "Creditadas na hora",
    get: "Assinar {plan}",
    addMonth: "Adicionar um mês",
    addYear: "Adicionar um ano",
    opensSoon: "Pagamentos em breve",
    alreadyMember: "Já é membro?",
    choose: "Escolha como pagar",
    payWith: "Pagar com",
    starsInBot: "{n} Stars no nosso bot do Telegram",
    card: "Cartão",
    crypto: "Cripto",
    cryptoMore: "BTC, USDT, ETH, TON e mais de 30 outras",
    tooManyStars: "Valor alto demais para um único pagamento em Telegram Stars.",
    cardMin: "Pagamentos com cartão a partir de {price}.",
    payStars: "Pagar com Telegram Stars",
    preparing: "Preparando o pagamento…",
    loginFirst: "Entre primeiro",
    cantStart: "Não foi possível iniciar o pagamento",
    noAdsCoins: "Sem anúncios + {n} Sweet Coins",
    addedOnPay: "Creditadas no seu saldo assim que você pagar",
    payInTelegram: "Pagar no Telegram",
    waitingStars: "Aguardando seu pagamento — esta página se atualiza sozinha",
    allSet: "Tudo certo!",
    noAds: "Sem anúncios.",
    noAdsUntil: "Sem anúncios até {date}.",
    coinsAdded: "{n} moedas já estão no seu saldo.",
    startWatching: "Começar a assistir",
    great: "Ótimo",
    payCard: "Pagar com cartão",
    failedTitle: "O pagamento não foi concluído",
    failedBody: "Nada foi cobrado. Você pode tentar de novo.",
    newTab: "Pague na nova aba",
    newTabBody: "Cartão, Apple Pay ou Google Pay, na página segura da Chain2Pay. Esta página se atualiza sozinha quando o pagamento for feito.",
    waiting: "Aguardando seu pagamento…",
    openAgain: "Abrir a página de pagamento de novo",
    somethingWrong: "Algo deu errado. Tente de novo em um minuto.",
    offline: "Parece que você está sem conexão. Tente de novo em um minuto.",
    bestValue: "Melhor custo-benefício",
    coins: "moedas",
    orStars: "ou {n} Stars",
    packsSoon: "Os pacotes de moedas chegam muito em breve.",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coins coletadas!",
    collectedToday: "Coletadas hoje",
    nextBonus: "Próximo bônus em",
    collecting: "Coletando…",
    collect: "Coletar {n} Sweet Coins",
    alreadyCollected: "Você já coletou as moedas de hoje. Volte amanhã.",
    offerLabel: "Sweet Coins e Premium",
    offerTitle: "Ganhe Sweet Coins",
    offerFor: "Para o Sweet Room e vídeos pagos",
    premiumFrom: "Premium a partir de {price}",
    upTo: "Sem anúncios + até {n} moedas",
    packsFrom: "Pacotes de moedas a partir de {price}",
    collectFree: "Ou colete moedas grátis todos os dias",
    offerButton: "Oferta de Sweet Coins",
    guestCollected: "+{n} Sweet Coins! Se você não quer perder suas moedas, cadastre-se no Sweet.",
    guestKeep: "Sem conta, as moedas ficam guardadas por {days} dias e depois se perdem.",
    guestSignup: "Cadastre-se grátis e guarde-as",
    guestLogin: "Já tem conta? Entrar",
    guestExpire: "{n} moedas serão perdidas em {date}.",
    guestUnsaved: "Suas moedas ainda não estão salvas: cadastre-se para guardá-las",
    guestExpiring: "{n} das suas Sweet Coins serão perdidas em menos de um dia. Cadastre-se grátis para guardá-las.",
  },
  footer: {
    copyright: "Direitos autorais",
    takedown: "Remoção de conteúdo",
    contact: "Contato",
    creators: "Criadores",
    claim: "Reivindique seu perfil",
    webmasters: "Webmasters",
    terms: "Termos",
    privacy: "Privacidade",
    info: "Informações do site",
    telegram: "{site} no Telegram",
  },
  report: {
    heading: "Denunciar um vídeo",
    reason: "Motivo",
    takedown: "Direitos autorais / DMCA",
    abuse: "Apareço neste vídeo sem meu consentimento",
    minor: "Alguém neste vídeo pode ter menos de 18 anos",
    other: "Outro motivo",
    url: "Link ou ID do vídeo",
    email: "Seu e-mail",
    details: "Detalhes",
    detailsPlaceholder: "O que devemos remover e por quê?",
    send: "Enviar denúncia",
  },
};
